import * as React from "react";
 
// importing material UI components
import { useState } from 'react';
import Container from '@mui/material/Container';
import CreateTemplate from './CreateTemplate';
import { 
  Grid,
  TextField,
  Typography,
} from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import Search from '@mui/icons-material/Search';
import Whatsapp from './Whatsapp';


const CreateTemplateManual = (props) => {
  const [showCreate, setShowCreate] = useState(true);
  const [templatesNamesData, setTemplatesNamesData] = useState([]);

  // When CreateTemplate is done, call this to show Whatsapp
  const handleDone = () => setShowCreate(false);

  return (
    <div className="App">
      {showCreate ? (
        <Container maxWidth={false}>
          <>
            {/* <h2 className="heading-title">Create Template</h2> */}
            <CreateTemplate 
              onNavigate={props.onNavigate}
              templatesNamesData={templatesNamesData}
              setComponent={handleDone} // Pass handler to move to Whatsapp
            />
          </>
        </Container>
      ) : (
        <Whatsapp {...props} />
      )}
    </div>
  );
}
export default CreateTemplateManual;